import { HTTP } from './_http';
import { queryString } from '../../helpers';

const getCompanyInfos = () => {
	return new Promise((resolve, reject) => {
		return HTTP.get(`/Definitions/GetEmployerHeaderAsync`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const updateCompany = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/Definitions/EmployerUpdateAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getAuthorizedUsers = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.get(`/Definitions/GetAuthorizedInformationListAsync?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getUserRoleList = () => {
	return new Promise((resolve, reject) => {
		return HTTP.get(`/Definitions/GetAuthorityCodeAsync`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const updateUserRole = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/Definitions/AgentDefinitionAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getCompanyInfos, updateCompany, getAuthorizedUsers, getUserRoleList, updateUserRole }